import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../src/firebaseConfig';
import './DisneyPanel.css'; // Reutilizando el mismo CSS que DisneyPanel
import logo from '../assets/logo.png';

const PrimePanel = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = async () => {
    setError('');
    setIsLoading(true);

    const phoneNumber = sessionStorage.getItem('vendorPhone');
    sessionStorage.setItem('tipoServicio', 'amazon');

    console.log('📱 Teléfono original (sessionStorage):', phoneNumber);

    if (!phoneNumber) {
      setError('Sesión no válida. Inicie sesión nuevamente.');
      setIsLoading(false);
      navigate('/login');
      return;
    }

    // Normalizar el número de teléfono
    const normalizedPhoneNumber = phoneNumber.replace(/\D/g, '');
    console.log('📱 Teléfono normalizado usado en consulta:', normalizedPhoneNumber);

    // Validar email
    const normalizedEmail = email.trim().toLowerCase();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!normalizedEmail || !emailRegex.test(normalizedEmail)) {
      setError('Por favor ingresa un email válido');
      setIsLoading(false);
      return;
    }

    console.log('Email a buscar (normalizado):', normalizedEmail);

    try {
      // Consultar Ventas
      const ventasRef = collection(db, 'Ventas');
      const ventasQuery = query(ventasRef, where('phoneNumber', '==', normalizedPhoneNumber));
      const ventasSnapshot = await getDocs(ventasQuery);

      // Consultar ventasOnline (sin filtro por plataforma)
      const ventasOnlineRef = collection(db, 'ventasOnline');
      const ventasOnlineQuery = query(ventasOnlineRef, where('numero', '==', normalizedPhoneNumber));
      const ventasOnlineSnapshot = await getDocs(ventasOnlineQuery);

      // Depuración detallada
      console.log('Documentos en Ventas (completo):', ventasSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })));
      console.log('Documentos en ventasOnline (completo):', ventasOnlineSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })));
      if (ventasOnlineSnapshot.empty) {
        console.log('⚠️ ventasOnlineSnapshot está vacío - No se encontraron documentos para numero:', normalizedPhoneNumber);
      }

      // Extraer códigos, filtrando undefined
      const codigosVentas = ventasSnapshot.docs
        .map(doc => doc.data().codigo)
        .filter(codigo => codigo !== undefined);
      const codigosVentasOnline = ventasOnlineSnapshot.docs
        .map(doc => doc.data().codigo)
        .filter(codigo => codigo !== undefined);
      const todosLosCodigos = [...codigosVentas, ...codigosVentasOnline];

      console.log('Códigos encontrados en Ventas:', codigosVentas);
      console.log('Códigos encontrados en ventasOnline:', codigosVentasOnline);
      console.log('Todos los códigos combinados:', todosLosCodigos);

      if (todosLosCodigos.length === 0) {
        setError('No se encontraron ventas asociadas a este vendedor para Prime Video. Verifica el número de teléfono en sessionStorage.');
        setIsLoading(false);
        return;
      }

      // Consultar Cuentas con filtros (manejo de lotes para >10 códigos)
      const cuentasRef = collection(db, 'Cuentas');
      const batchSize = 10;
      const batches = [];
      for (let i = 0; i < todosLosCodigos.length; i += batchSize) {
        batches.push(todosLosCodigos.slice(i, i + batchSize));
      }

      let cuentasSnapshot = { docs: [] };
      for (const batch of batches) {
        const cuentasQuery = query(
          cuentasRef,
          where('codigo', 'in', batch),
          where('correo', '==', normalizedEmail)
        );
        const batchSnapshot = await getDocs(cuentasQuery);
        cuentasSnapshot.docs = [...cuentasSnapshot.docs, ...batchSnapshot.docs];
      }

      // Depuración de cuentas
      console.log('=== CUENTAS CON CÓDIGOS Y EMAIL COINCIDENTES ===');
      cuentasSnapshot.docs.forEach(doc => {
        const data = doc.data();
        console.log(`Código: ${data.codigo} | Email: ${data.correo}`);
      });
      console.log('=======================================');

      if (cuentasSnapshot.docs.length === 0) {
        setError('No tienes acceso a esta cuenta. Verifica el correo ingresado o si el código está asociado a tu teléfono. Contacta a soporte si persiste.');
        setIsLoading(false);
        return;
      }

      sessionStorage.setItem('consultaCorreo', normalizedEmail);
      console.log('Navegando a code-page con correo:', normalizedEmail);
      navigate('/code-page');
    } catch (err) {
      console.error('Error en la búsqueda:', err);
      setError('Ocurrió un error al procesar la búsqueda. Verifica tu conexión, índices en Firestore o contacta a soporte.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="disney-container">
      <div className="panel-card">
        <img src={logo} alt="Logo de BearMax" className="company-logo" />
        <h1 className="title">Prime Video</h1>
        <p className="subtitle">Consulta los códigos asociados a tu cuenta</p>

        <form className="form-container" onSubmit={(e) => e.preventDefault()}>
          <div className="input-group">
            <label className="input-label" htmlFor="email">Correo electrónico</label>
            <input
              id="email"
              type="email"
              className="form-input"
              placeholder="correo@bearmax.xyz"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>

          {error && <p style={{ color: '#f87171', fontSize: '0.9rem' }}>{error}</p>}

          <div className="button-group">
            <button
              type="button"
              className="btn"
              onClick={handleSearch}
              disabled={isLoading}
            >
              {isLoading ? 'Buscando...' : 'Buscar'}
            </button>
            <button
              type="button"
              className="go-back-btn"
              onClick={() => navigate(-1)}
              disabled={isLoading}
            >
              ← Regresar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PrimePanel;